import styled from '@emotion/styled'

export const StyleBannerBg = styled.div`
  background: ${(props: any) => props.theme.colors.pink100};
  padding: 0px 40px;
  border-radius: 24px;
  display: flex;
  justify-content: space-between;
  border: 1px solid ${(props: any) => props.theme.colors.pink300};
`

export const StyleLeftBannerWrapper = styled.div`
  display: flex;
  row-gap: 15px;
  flex-direction: column;
  justify-content: center;
  height: 200px;
`
export const StyleRightBannerWrapper = styled.div`
  img {
    height: 200px;
  }
`
